const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

/**
 * @param {string} date - формат строки должен быть 'дд-мм-гггг чч:мм:сс'
 * @return {string} - возвращает дату без времени
 */
const getDateFromString = (date) => { 
    if(!date) return ""
    return date.split(" ")[0]
 }

 /**
 * @param {Date} date - дата
 * @param {boolean} withoutDay - true => 'мм-гггг', false => 'дд-мм-гггг'
 * @return {string} - возвращает строку с датой без времени 'мм-гггг' или 'дд-мм-гггг'
 */

 const formatDate = (date, withoutDay = false) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return withoutDay ? [year, month].join('-')
        :
        [year, month, day].join('-');
}

const formatTime = (date) => {
  const formatDate = new Date(date);
  let hours = String(formatDate.getHours());
  let minutes = String(formatDate.getMinutes());
  let seconds = String(formatDate.getSeconds());
  hours = hours.length === 1 ? "0" + hours : hours;
  minutes = minutes.length === 1 ? "0" + minutes : minutes;
  seconds = seconds.length === 1 ? "0" + seconds : seconds;

  return `${hours}:${minutes}:${seconds}`;
};

/**
 * @param {object} date - формат строки должен быть 'дд-мм-гггг чч:мм:сс'
 * @return {number} - возвращает дату без времени
 */
const getMonth = (date) => { 
    if(!date) return 0
    let month = String(date.getMonth()+1); 
    if(month.length===1){
        month = "0"+month;
    }
    return month;
 }

const getNextMonth = (date) => { 
    if(!date) return 0
    let month = date.getMonth(); 
    if(month+1>11){
        month = "01";
    }else{
        month = String(month+2);
    }
    if(month.length===1){
        month = "0"+month;
    }
    return month;
 }

 const getPrevMonth = (date) => { 
    if(!date) return 0
    let month = date.getMonth(); 
    if(month-1<0){
        month = "12";
    }else{
        month = String(month);
    }
    if(month.length===1){
        month = "0"+month;
    }
    return month;
 }


 const getNextYear = (date) => { 
    if(!date) return 0
    let year = date.getFullYear(); 
    if(year+1>9999){
        year = "0001";
    }else{
        year = String(year+1);
    }
    while(year.length<4){
        year = "0" + year;
    }
    return year;
 }

 const getPrevYear = (date) => { 
    if(!date) return 0
    let year = date.getFullYear(); 
    if(year-1<1){
        year = "9999";
    }else{
        year = String(year-1);
    }
    while(year.length<4){
        year = "0" + year;
    }
    return year;
 }

 const getDay = (date) => {
    let day = String(date.getDay());
    day = day.length < 2 ? "0"+String(day) : day;
    return day;
  };

  const compareDates = (fDate, sDate) => { 
    const fDay = fDate.getDate();
    const fMonth = fDate.getMonth();
    const fYear = fDate.getFullYear();
    const sDay = sDate.getDate();
    const sMonth = sDate.getMonth();
    const sYear = sDate.getFullYear();
    if(fDay === sDay && fMonth=== sMonth&& fYear === sYear){
      return 0
    }else if(fDate<sDate){
      return -1
    }else if(fDate>sDate){
      return 1
    }
   }

   const diffDates = (date1, date2) => {
        const millisecondsDiff = (new Date(date1)).getTime() - (new Date(date2)).getTime()
        return Math.abs(millisecondsDiff);
    }

   const msConvert = (mseconds, from="h") => {
        switch (from) {
            case "h":
                return getFromHours(mseconds);
            default:
                return false;
        }
   }

   const getFromHours = (mseconds) => {
       const addZero = (data) => { 
           let result = String(data)
           return result.length===1?"0"+ data: data;
        }
       const hours = Math.trunc(mseconds / HOUR);
       const minutes = Math.trunc((mseconds - (hours * HOUR)) / MINUTE)
       const seconds = Math.trunc((mseconds - (hours * HOUR + minutes * MINUTE ) ) / SECOND)
       return {
           numbers:{hours, minutes, seconds},
           strings:{hours:addZero(hours), minutes:addZero(minutes), seconds:addZero(seconds)},
           text:`${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`,
       }
    }

const dateUtils = { 
    getDateFromString,
    getMonth,
    getNextMonth,
    getPrevMonth,
    formatDate,
    getNextYear,
    getPrevYear,
    getDay,
    compareDates,
    formatTime,
    diffDates,
    msConvert,
    getFromHours
}

export default dateUtils;